import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import "../../styles/signUpDialog.css";
import InputStyle from "../../assets/InputStyle";
import SignUpAs from "./SignUpAs";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { reset } from "../../actions/userAuth";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';

export default function ResetPasswordModal({ resetPasswordAction, setResetPasswordAction, activationToken }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    setResetPasswordAction(false);
  }
  const dispatch = useDispatch();


  const handlePasswordVisibility = (id, state, setState) => {
    if (state) {
      document.getElementById(id).type = "password";
    } else {
      document.getElementById(id).type = "text";
    }
    setState(!state);
  }

  const handleResetPassword = () => {
    setLoading(true);
    if (!password || !confirmPassword) {
      enqueueSnackbar("Please fill all the fields", { variant: 'error' });
      setLoading(false);
    } else if (password != confirmPassword) {
      enqueueSnackbar("Password and confirm password", { variant: 'error' });
      setLoading(false);
    } else if (password.length <= 5) {
      enqueueSnackbar("Password length must be greater that 5 charactors", { variant: 'error' });
      setLoading(false);
    } else {
      dispatch(reset({ password }, (data) => {
        setLoading(false);
        setResetPasswordAction(false);
        enqueueSnackbar(data.data.msg, { variant: 'success' });
      }, (err) => {
        console.log(err)
        enqueueSnackbar("Error occured! please try again", { variant: 'error' });
        setLoading(false);
      },
        activationToken))
    }
  }

  return (
    <>
      <Dialog
        open={resetPasswordAction}
        onClose={closeHandler}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <CloseIcon sx={{ float: 'right', cursor: 'pointer' }} onClick={closeHandler} />
        </DialogTitle>
        <DialogContent>
          <Box px={6} py={3}>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 4,
                textAlign: "center",
                color: "#2544EE",
                fontSize: 22,
                fontFamily: "Inter",
              }}
              component={"h3"}
            >
              Reset Your Password
            </Typography>

            <Stack spacing={3} pt={1} >
              <InputStyle name="Create Password" topSpace={true}>
                <input
                  id={"password"}
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {
                  passwordVisibility
                    ?
                    <Visibility onClick={() => handlePasswordVisibility("password", passwordVisibility, setPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                    :
                    <VisibilityOff onClick={() => handlePasswordVisibility("password", passwordVisibility, setPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                }
              </InputStyle>

              <InputStyle name="Confirm Password" topSpace={true}>
                <input
                  id={"confirmPassword"}
                  type="password" placeholder="Re-enter password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {
                  confirmPasswordVisibility
                    ?
                    <Visibility onClick={() => handlePasswordVisibility("confirmPassword", confirmPasswordVisibility, setConfirmPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                    :
                    <VisibilityOff onClick={() => handlePasswordVisibility("confirmPassword", confirmPasswordVisibility, setConfirmPasswordVisibility)} style={{ marginLeft: '-30px', cursor: 'pointer' }} />
                }
              </InputStyle>

              <Button
                variant="contained"
                fullWidth
                onClick={handleResetPassword}
                sx={{ bgcolor: "#2544EE", width: '92%' }}
                disabled={loading}
              >
                {
                  loading
                    ?
                    <CircularProgress size={24} />
                    :
                    "Submit"
                }
              </Button>
            </Stack>
          </Box>
        </DialogContent>
      </Dialog>

    </>
  );
}
